import axios from 'axios';
import { getCurrentSession } from './auth';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use(async (config) => {
  const session = await getCurrentSession();
  if (session) {
    config.headers.Authorization = `Bearer ${session.token}`;
  }
  return config;
});

export interface Patient {
  internal_id: number;
  hm_id: string;
  clinic: string;
  status: string;
  created_date: string | null;
  waiting_time: number;
}

export interface PatientListResponse {
  total: number;
  patients: Patient[];
}

export const patientsApi = {
  list: (limit = 200) =>
    api.get<PatientListResponse>('/api/patients', { params: { limit } }),
};

export default api;
